export type GygWidgetDensity = 'compact' | 'default';

const DEFAULT_NUMBER_OF_ITEMS = 3;
const COMPACT_DESKTOP_NUMBER_OF_ITEMS = 3;
const COMPACT_MOBILE_NUMBER_OF_ITEMS = 3;

/** Fixed height for three vertically stacked GYG cards on mobile (rating + image + title each). */
export const GYG_WIDGET_COMPACT_MOBILE_SLOT_CLASS = 'relative h-[1140px] overflow-hidden';

/** Scales GYG card chrome down inside the compact slot so rating lines stay visible (desktop). */
export const GYG_WIDGET_COMPACT_SCALE = 0.9;

/**
 * Resolves how many GYG activity cards to request for a given density and viewport.
 */
export function resolveGygWidgetNumberOfItems(
  density: GygWidgetDensity,
  isMobileViewport: boolean,
  explicit?: number,
): number {
  if (explicit != null) {
    return explicit;
  }

  if (density === 'compact') {
    return isMobileViewport
      ? COMPACT_MOBILE_NUMBER_OF_ITEMS
      : COMPACT_DESKTOP_NUMBER_OF_ITEMS;
  }

  return DEFAULT_NUMBER_OF_ITEMS;
}

/**
 * Fixed slot height for compact embeds (place modal).
 * Mobile: three vertically stacked cards. Desktop: horizontal row with scaled cards.
 */
export const GYG_WIDGET_COMPACT_SLOT_CLASS =
  'relative sm:h-[400px] overflow-hidden';

export function resolveGygCompactSlotClass(isMobileViewport: boolean): string {
  return isMobileViewport ? GYG_WIDGET_COMPACT_MOBILE_SLOT_CLASS : GYG_WIDGET_COMPACT_SLOT_CLASS;
}

/** Desktop-only scale so image + rating fit the horizontal row without clipping. */
export const GYG_WIDGET_COMPACT_INNER_SIZE_CLASS =
  'h-full w-full sm:h-[111.11%] sm:w-[111.11%] sm:origin-top-left sm:scale-90';

export function resolveGygCompactInnerClass(isMobileViewport: boolean): string {
  return isMobileViewport ? 'h-full w-full' : GYG_WIDGET_COMPACT_INNER_SIZE_CLASS;
}

/** @deprecated Use GYG_WIDGET_COMPACT_SLOT_CLASS */
export const GYG_WIDGET_COMPACT_CONTAINER_CLASS = GYG_WIDGET_COMPACT_SLOT_CLASS;
